import { ContactUsForm } from "@/components/Contact/ContactUsForm";
import { Section, SectionContainer } from "@/components/Sections";
import SpinnerOverlay from "@/components/SpinnerOverlay";
import { useSystemMessages } from "@/hooks/useSystemMessages";
import { InferGetStaticPropsType, NextPage } from "next";
import { useState } from "react";
import { Head } from "@/components/Head";
import { useBaseContext } from "@/components/BaseContext";
import { useProfile } from "@/components/HeaderMain/useProfile";
import { useRouter } from "next/router";
import config from "../config";


export const getStaticProps = async () => {
  return {
    props: {},
    revalidate: config.staticRevalidationTime,
  } as const;
};

type Props = InferGetStaticPropsType<typeof getStaticProps>; 
const ContactUsPage:NextPage<Props> = () => {

  const [isLoading, setIsLoading] = useState(false);
  const { FixedSystemMessageList, addSystemMessage } = useSystemMessages();
  const TIME_SHOW_MESSAGES_SECONDS = 8;
  const { profile } = useProfile();
  const  router  = useRouter();
  const base = useBaseContext();

  return (
    <>
      <Head
        title="Contact"
        description="Contact us regarding any issue you are facing or question you may have."
      />
      <FixedSystemMessageList />
      <Section color="white" isFirstSection>
        <SectionContainer>
          {isLoading && (
            <SpinnerOverlay
              isTransparent
              loadingText="Sending request for support..."
            />
          )}
          <div className="flex justify-center">
            <ContactUsForm
              universities={base.memberUniversities}
              supportSettings={base.contactFormSettings}
              learningOppNames={base.learningOppNames}
              profile={profile ?? undefined}
              onSendStateChanged={(newState) => {
                switch (newState) {
                  case "loading":
                    setIsLoading(true);
                    break;
                  case "error":
                    setIsLoading(false);
                    addSystemMessage({
                      props: {
                        kind: "error",
                      },
                      text: "An error has occurred. Try again later or contact helpdesk@eciu.eu.",
                      dismissAfterSeconds: TIME_SHOW_MESSAGES_SECONDS,
                    });
                    break;
                  case "success":
                    setIsLoading(false);
                    addSystemMessage({
                      text: `Your request for support has been received. We will get back to you as soon as possible.`,
                      props: {
                        kind: "success",
                      },
                      dismissAfterSeconds: TIME_SHOW_MESSAGES_SECONDS,
                    });
                    setTimeout(() => { router.back() }, TIME_SHOW_MESSAGES_SECONDS *500);
                    break;
                }
              }}
            />
          </div>
        </SectionContainer>
      </Section>
    </>
  );
};

export default ContactUsPage;